import { memo, useEffect } from "react";
import { useRouter } from "next/router";
import { AUTH_REDIRECT_PATH } from "modules/utils/Constants";

const IndexComponent = () => {
  const { pathname, replace } = useRouter();
  useEffect(() => {
    replace({
      pathname: AUTH_REDIRECT_PATH,
    });
  }, [pathname, replace]);

  return null;
};

export default memo(IndexComponent);
